import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from 'vue-property-decorator';

import { ScheduleService } from '@/tools/services/schedule.service';
import { Placeholder, ScheduleClass, ScheduleResponseDto } from '@/tools/models/class-builder.models';
import { IScheduleEntryResponse } from '@/tools/interfaces/schedule-entry.interface';

@Component({
  components: {
    EdClassBuilder: () => import(/* EdClassBuilder */'@/tools/components/class-builder/ed-class-builder/ed-class-builder.component.vue')
  }
})
export default class EdClassBuilderView extends Vue {
  classId: number = -1;

  get organizationId(): number {
    return this.$store.state.ToolsStore.institutionInfo[0]?.organizationId || 0;
  }

  created() {
    this.classId = Number(this.$route.params.classId);
  }

  returnToAdmin() {
    this.$router.push({ name: 'class-admin' });
  }

  goToPlaceholderCalendar(placeholder: Placeholder) {
    this.$router.push({ name: 'builder-placeholder', params: { placeholderId: placeholder.id.toString() } });
  }
}